import axios from 'axios';
import {BACKEND_URL} from '../constants/ServiceUrl'

export default {
    getPerStatus(data){
        return axios.post(BACKEND_URL+'ValidationCard/getPerStatus.php',data);
    },
    getStatusPerRepGroup(data){
        return axios.post(BACKEND_URL+'ValidationCard/getStatusPerRepGroup.php',data);
    },
    getPerUser(data){
        return axios.post(BACKEND_URL+'ValidationCard/getPerUser.php',data);
    },
    getByLevel(data){
        return axios.post(BACKEND_URL+'ValidationCard/getByLevel.php',data);
    },
    getReportingYearLov() {
        return axios.get(BACKEND_URL+'ValidationCard/getReportingYearLov.php');
    },
    add(data) {
        return axios.post(BACKEND_URL+'ValidationCard/add.php',data);
    },
    addMultiple(data) {
        return axios.post(BACKEND_URL+'ValidationCard/addMultiple.php',data);
    },
    update(data) {
        return axios.put(BACKEND_URL+'ValidationCard/update.php',data);
    },
    get(id) {
        return axios.get(BACKEND_URL+'ValidationCard/get.php?id='+id);
    },
    getInProgress(data) {
        return axios.post(BACKEND_URL+'ValidationCard/getInProgress.php',data);
    },
    getNotBacklog(data) {
        return axios.post(BACKEND_URL+'ValidationCard/getNotBacklog.php',data);
    },
    addAttestation(data) {
        return axios.post(BACKEND_URL+'ValidationCard/VcardAttestation/add.php',data);
    },
    getValidated(data) {
        return axios.post(BACKEND_URL+'ValidationCard/getValidated.php',data);
    },
    getReadyValidated(data) {
        return axios.post(BACKEND_URL+'ValidationCard/getReadyValidated.php',data);
    },
    delete(id){
        return axios.delete(BACKEND_URL+'ValidationCard/delete.php?id='+id);
    },
    getGroupStatus(data) {
        return axios.post(BACKEND_URL+'ValidationCard/getGroupStatus.php',data);
    }
}


// WEBPACK FOOTER //
// ./src/api/ValidationCardApi.js